import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['vessel', 'vesselCard', 'marketRatesBar', 'addVesselWrapper', 'newVesselInput', 'vesselsActionButtons']

  connect() {
    this.element.addEventListener("calculator:showVessels", () => this.showVessels())
    this.element.addEventListener("calculator:closeVessels", () => this.closeVessels())
    this.boundScrollHandler = (event) => this.scrollToVessel(event)
    this.element.addEventListener("calculator:scrollToVessel", this.boundScrollHandler)
    this.boundPostCalculationHandler = (event) => this.handlePostCalculation(event)
    this.element.addEventListener("calculator:postCalculation", this.boundPostCalculationHandler)
    this.element.addEventListener('value-guidance:vesselRemoved', (e) => this.removeVesselByImo(e.detail?.imo))

    // Listen for back button events from breadcrumbs
    this.boundBackHandler = this.handleBackButton.bind(this)
    document.addEventListener('calculator:backButton', this.boundBackHandler)
  }

  disconnect() {
    document.removeEventListener('calculator:backButton', this.boundBackHandler)
    if (this.boundScrollHandler) {
      this.element.removeEventListener("calculator:scrollToVessel", this.boundScrollHandler)
    }
    if (this.boundPostCalculationHandler) {
      this.element.removeEventListener("calculator:postCalculation", this.boundPostCalculationHandler)
    }
  }

  handleBackButton(customEvent) {
    // Check if any vessels are hidden (meaning a vessel form is open)
    const anyVesselHidden = this.vesselTargets.some(v => v.classList.contains('d-none'))

    // Check if admiralty is open by looking for visible admiralty content
    const admiraltyOpen = document.querySelector('[data-calculator-vessel-target="admiraltyContent"]:not(.d-none)') !== null

    if (anyVesselHidden || admiraltyOpen) {
      // Vessel form or admiralty is open - prevent navigation and show vessels list
      const originalEvent = customEvent.detail.originalEvent
      if (originalEvent) {
        originalEvent.preventDefault()
      }
      this.showVessels()
      // Close any open vessel forms and admiralty
      document.querySelectorAll('[data-controller*="calculator-vessel"]').forEach(el => {
        el.dispatchEvent(new CustomEvent("calculator-vessel:closeVessel", { bubbles: true }))
        el.dispatchEvent(new CustomEvent("calculator-vessel:closeAdmiralty", { bubbles: true }))
      })
    }
    // Otherwise, allow normal navigation to client area
  }

  closeVessels() {
    this.vesselTargets.forEach(v => v.classList.add('d-none'))
    if (this.hasMarketRatesBarTarget) {
      this.marketRatesBarTarget.classList.add('d-none')
    }
    this.hideMobileButtons()
  }

  showVessels() {
    this.vesselTargets.forEach(v => v.classList.remove('d-none'))
    if (this.hasMarketRatesBarTarget) {
      this.marketRatesBarTarget.classList.remove('d-none')
    }
    this.showMobileButtons()
  }

  hideMobileButtons() {
    if (this.hasVesselsActionButtonsTarget) {
      this.vesselsActionButtonsTarget.classList.add('d-none')
    }
  }

  showMobileButtons() {
    if (this.hasVesselsActionButtonsTarget) {
      this.vesselsActionButtonsTarget.classList.remove('d-none')
    }
  }

  // TODO: temporary until we move to calculator_vessel_controller
  removeVesselByImo(imo) {
    if (!imo) return
    const form = this.element.querySelector(`form[data-imo="${imo}"]`)
    if (form) form.remove()
    this.hideLoading()
  }

  scrollToVessel(event) {
    const imo = event?.detail?.imo
    if (!imo) return
    if (window.innerWidth >= 576) return

    requestAnimationFrame(() => {
      const vesselCard = this.vesselCardTargets.find(card => card.dataset.imo === imo)
      if (vesselCard) {
        vesselCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  }

  handlePostCalculation(event) {
    const imo = event?.detail?.imo
    if (!imo) return

    const vesselCard = this.vesselCardTargets.find(card => card.dataset.imo === imo)
    if (vesselCard) {
      vesselCard.dispatchEvent(new CustomEvent("calculator-vessel:closeVessel", { bubbles: true }))
    }

    this.showVessels()
  }

  async addVessel(event) {
    event.preventDefault()

    this.closeVessels()
    const url = event.currentTarget.href
    const response = await fetch(url, {
      headers: { "Accept": "text/vnd.turbo-stream.html, text/html" }
    })
    const html = await response.text()

    if (!this.hasNewVesselInputTarget) {
      this.addVesselWrapperTarget.insertAdjacentHTML("beforeend", html)
      if (this.hasNewVesselInputTarget) {
        this.newVesselInputTarget.focus()
      }
    }
  }

  submitCalculations(event) {
    event.preventDefault()
    const form = document.getElementById('vessels-form')
    if (!form) return

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
